import { NetworkStatus, useQuery } from '@apollo/client';
import EvaluationFormTemplate from 'components/Forms/EvaluationFormTemplate';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import {
  GetUserGoalsResponse,
  GetUserGoalsVariables,
  GET_USER_GOALS,
  GetUserByIdResponse,
  GetUserByIdVariables,
  GET_USER_BY_ID_QUERY,
} from 'graphql/query/user';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const ReporteeEvaluationFormPage = () => {
  const { userId = '' } = useParams<{ userId: string }>();
  const [searchParams] = useSearchParams();
  const providedPeriod = searchParams.get('period');
  const navigate = useNavigate();

  const { data: userGoals, networkStatus: userGoalsNetworkStatus } = useQuery<
    GetUserGoalsResponse,
    GetUserGoalsVariables
  >(GET_USER_GOALS, {
    variables: {
      user: userId,
      year: getSelectedObjectiveGoalsYear(),
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const { data: user, networkStatus: userNetworkStatus } = useQuery<
    GetUserByIdResponse,
    GetUserByIdVariables
  >(GET_USER_BY_ID_QUERY, {
    variables: {
      user: userId,
      year: getSelectedObjectiveGoalsYear(),
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });

  const loadingUser = userNetworkStatus === NetworkStatus.loading || !!!user;
  const loadingUserGoals = userGoalsNetworkStatus === NetworkStatus.loading || !!!userGoals;
  const userName = user?.getUserById.name;

  useEffect(() => {
    let isValidPeriod = true;
    if (!!user) {
      if (
        !!providedPeriod &&
        !!!Number.isNaN(providedPeriod) &&
        +providedPeriod > 0 &&
        +providedPeriod < 4
      ) {
        if (+providedPeriod > (user?.getUserById?.annualUserInfo?.period ?? 0))
          isValidPeriod = false;
      } else isValidPeriod = false;
      if (!isValidPeriod) {
        toast.error('This activity is not started yet.');
        navigate(-1);
      }
    }
  }, [user]);

  const calculateTitle = () => {
    switch (providedPeriod) {
      case '1':
        return `${userName}'s Objective Settings - ${getSelectedObjectiveGoalsYear()}`;

      case '2':
        return `${userName}'s Mid Year Review - ${getSelectedObjectiveGoalsYear()}`;

      case '3':
        return `${userName}'s End Year Review - ${getSelectedObjectiveGoalsYear()}`;

      default:
        return '';
    }
  };

  return (
    <Navbar
      goBackButtonConfig={{
        title: calculateTitle(),
      }}
    >
      {loadingUser || loadingUserGoals ? (
        <LoadingIndicator />
      ) : (
        <>
          <EvaluationFormTemplate
            period={+(providedPeriod ?? '')}
            employee={user.getUserById}
            initialRows={!!userGoals.getUserGoals.length ? userGoals.getUserGoals : undefined}
          />
        </>
      )}
    </Navbar>
  );
};

export default ReporteeEvaluationFormPage;
